export const ProgressSteps = ({ currentStep, language }) => {
    const steps = [
        {
            id: 1,
            labelEn: "Upload PDF",
            labelZh: "上傳PDF",
            icon: (
                <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                    />
                </svg>
            ),
        },
        {
            id: 2,
            labelEn: "Review & Edit",
            labelZh: "審核編輯",
            icon: (
                <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                    />
                </svg>
            ),
        },
        {
            id: 3,
            labelEn: "Complete",
            labelZh: "完成",
            icon: (
                <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                    />
                </svg>
            ),
        },
    ];

    return (
        <div className="mb-6 bg-white rounded-xl p-6 border border-gray-200">
            <div className="flex items-center justify-between relative max-w-2xl mx-auto">
                {/* Progress Line Background */}
                <div
                    className="absolute top-1/3 left-5 w-11/12 h-1 bg-gray-200 "
                    style={{ zIndex: 0 }}
                />
                {/* Active Progress Line */}
                <div
                    className="absolute top-1/3 left-5 h-1 bg-orange-500 transition-all duration-500"
                    style={{
                        width: `${
                            ((currentStep - 1) / (steps.length - 1)) * 100
                        }%`,
                        zIndex: 0,
                    }}
                />

                {steps.map((step, index) => {
                    const isCompleted = currentStep > step.id;
                    const isActive = currentStep === step.id;

                    return (
                        <div
                            key={step.id}
                            className="flex flex-col items-center relative"
                            style={{ zIndex: 1 }}
                        >
                            {/* Step Circle */}
                            <div
                                className={`w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 mb-2 ${
                                    isCompleted
                                        ? "bg-orange-500 text-white shadow-lg shadow-orange-500/50"
                                        : isActive
                                          ? "bg-orange-500 text-white shadow-lg shadow-orange-500/50 scale-110"
                                          : "bg-white border-2 border-gray-300 text-gray-400"
                                }`}
                            >
                                {isCompleted ? (
                                    <svg
                                        className="w-5 h-5"
                                        fill="currentColor"
                                        viewBox="0 0 20 20"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                ) : (
                                    step.icon
                                )}
                            </div>
                            {/* Step Label */}
                            <p
                                className={`text-xs font-medium text-center whitespace-nowrap transition-colors ${
                                    isActive
                                        ? "text-orange-500"
                                        : isCompleted
                                          ? "text-gray-900"
                                          : "text-gray-400"
                                }`}
                            >
                                {language === "zh"
                                    ? step.labelZh
                                    : step.labelEn}
                            </p>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
